<template>
  <div>
    <wc-data-box
      :title='details.title'
      :titleIcon='details.icon'
      :titleIconColor='details.iconColor'
      showEdit
      @edit='editDetails'
    >
      <wc-two-column-table :items='items'></wc-two-column-table>
      <v-card-text class='pt-0'>
        {{ project.project_detail.lawn_signs_note }}
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='details.title'
      :icon='details.icon'
      :iconColor='details.iconColor'
      @cancel='cancelEdit'
      @save='saveEdit'
    >
      <v-form v-model='isFormValid' ref='form'>
         <v-row dense>
          <v-col cols='12' md='6'>
            <wc-datepicker :max='projectCopy.end_date' v-model='projectCopy.start_date' label='Lawn Care Start date'></wc-datepicker>
          </v-col>
          <v-col cols='12' md='6'>
            <wc-datepicker :min='projectCopy.start_date' v-model='projectCopy.end_date' label='Lawn Care End date'></wc-datepicker>
          </v-col>
          <v-col cols='12'>
            <v-checkbox hide-details v-model='projectCopy.project_detail.spring_cleanup' label='Spring Cleanup'></v-checkbox>
          </v-col>
          <v-col cols='11' offset='1' v-if='projectCopy.project_detail.spring_cleanup'>
            <v-checkbox hide-details small v-model='projectCopy.project_detail.aeration' label='Aeration'></v-checkbox>
            <v-checkbox hide-details small v-model='projectCopy.project_detail.power_raking' label='Power Raking'></v-checkbox>
            <v-checkbox hide-details small v-model='projectCopy.project_detail.mowing' label='Mowing'></v-checkbox>
            <v-checkbox hide-details small v-model='projectCopy.project_detail.trimming' label='Trimming'></v-checkbox>
            <v-checkbox hide-details small v-model='projectCopy.project_detail.edging' label='Edging'></v-checkbox>
          </v-col>
          <v-col cols='12'>
            <v-checkbox hide-details v-model='projectCopy.project_detail.lawn_care' label='Lawn Care'></v-checkbox>
          </v-col>
          <v-col cols='12' v-if='projectCopy.project_detail.lawn_care' class='mt-4'>
            <v-select
              label='Mowing Frequency'
              :items='frequencyOptions'
              dense
              v-model='projectCopy.frequency'
            ></v-select>
          </v-col>
          <v-col cols='12'>
            <v-checkbox hide-details v-model='projectCopy.project_detail.fertilizer' label='Fertilizer / Weed Control'></v-checkbox>
          </v-col>
           <v-col cols='12'>
            <v-checkbox hide-details v-model='projectCopy.project_detail.additional_work' label='Additional Work'></v-checkbox>
          </v-col>
          <v-col cols='12'>
            <v-text-field outlined v-model='projectCopy.project_detail.additional_spring_cleanup_fees' label='Additional Spring Cleanup Fee'></v-text-field>
          </v-col>
          <v-col cols='12'>
            <v-text-field outlined v-model='projectCopy.project_detail.additional_lawn_care_fee' label='Additional Lawn Care Fee'></v-text-field>
          </v-col>
          <v-col cols='12'>
            <v-text-field outlined v-model='projectCopy.project_detail.additional_fertilizer_fee' label='Additional Fertilizer Fee'></v-text-field>
          </v-col>
          <v-col cols='12' v-if='projectCopy.project_detail.additional_work'>
            <v-textarea outlined v-model='projectCopy.project_detail.additional_work_description' label='Description'></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import formRules from '@/mixins/formRules'

export default {
  name: 'lawn-project-details',
  mixins: [formRules],
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showDialog: false,
    projectCopy: {project_detail: {}}
  }),
  computed: {
    items () {
      let table = [
        { text: 'Lawn Care Start Date', value: this.project.start_date ? this.$options.filters.shortDate(this.project.start_date) : 'Not set' },
        { text: 'Lawn Care End Date', value: this.project.end_date ? this.$options.filters.shortDate(this.project.end_date) : 'Not set' },
        { text: 'Spring Cleanup', value: this.$options.filters.trueFalse(this.project.project_detail.spring_cleanup) },
        { text: 'Additional Spring Cleanup Fees', value: '$' + this.project.project_detail.additional_spring_cleanup_fees},
        { text: 'Additional Lawn Care Fees', value: '$' + this.project.project_detail.additional_lawn_care_fee},
        { text: 'Additional Fertilizer Fees', value: '$' + this.project.project_detail.additional_fertilizer_fee}
      ]
      if (this.project.project_detail.spring_cleanup) {
        table.push({ text: 'Priority Spring Cleanup?', value:this.$options.filters.trueFalse(this.project.project_detail.priority_spring_cleanup) })
        table.push({ text: 'Options', value: this.springCleanupOptions })
      }
        table.push({ text: 'Lawn Care', value: this.$options.filters.trueFalse(this.project.project_detail.lawn_care) })
      if (this.project.project_detail.lawn_care) {
        table.push({ text: 'Frequency', value: this.getFrequencyDisplay(this.project.frequency) })
      }
        table.push({ text: 'Weed Control / Fertilizer', value: this.$options.filters.trueFalse(this.project.project_detail.fertilizer) })
        table.push({ text: 'Additional Work:', value: this.$options.filters.trueFalse(this.project.project_detail.additional_work) })
      if (this.project.project_detail.additional_work) {
        table.push({ text: 'Details:', value: this.project.project_detail.additional_work_description })
      }
      return table
    },
    springCleanupOptions () {
      let tmp = ""
      if (!this.project.project_detail.aeration) { tmp += "No Aerating, " }
      if (!this.project.project_detail.power_raking) { tmp += "No Power Raking, " }
      if (!this.project.project_detail.mowing) { tmp += "No Mowing, " }
      if (!this.project.project_detail.trimming) { tmp += "No Trimming, " }
      if (!this.project.project_detail.edging) { tmp += "No Edging, " }
      if (tmp === "") {
        return "Standard Cleanup"
      }
      return tmp
    },
    frequencyOptions () {
      return this.$store.state.misc.globalOptions.frequency
    },
    ...mapState ({
      details: state => state.icons.dataBox.details,
    })
  },
  methods: {
    editDetails () {
      this.projectCopy = _.cloneDeep(this.project)
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    saveEdit () {
      this.$emit('update', this.projectCopy)
      this.cancelEdit()
    },
    getFrequencyDisplay (val) {
      if (this.frequencyOptions.find(o => o.value === val) !== undefined) {
        return this.frequencyOptions.find(o => o.value === val).text
      }
      return ''
    },
  }
}
</script>